'use strict';

import vex from 'vex-js';

const config = {
    clickEvent: 'click touch',
    closeTarget: '.vex-close',
    modalContentContainer: '.c-hero-banner__video-container',
    modalContents: '.c-hero-banner__video',
    triggerTarget: '.js-video-modal-trigger',
    vexTheme: 'vex-theme-plain'
};

class VideoModal {

    constructor() {
        if(!$(config.triggerTarget).length) {
            return;
        }

        this.setupClickEvents();
    }

    /**
     * Sets up all click events for the VideoModal component
     */
    setupClickEvents() {
        $(config.triggerTarget).on(config.clickEvent, (e) => this.handleOpenModal(e));
    }

    /**
     * Handles trigger for opening the modal
     *
     * @param {event} e
     */
    handleOpenModal(e) {
        e.preventDefault();

        var $modalContents = $(e.target)
            .closest(config.triggerTarget)
            .nextAll(config.modalContentContainer)
            .find(config.modalContents)
            .clone();

        var $contentClassName = $(e.target).closest(config.triggerTarget).hasClass('article-video-trigger') ?
            'article-video' :
            null;

        this.vex = vex.open({
            content: $modalContents,
            className: 'vex-theme-plain no-padding-darker-theme',
            contentClassName: $contentClassName
        });

        $(config.closeTarget, this.vex[0]).on(config.clickEvent, (e) => this.handleCloseDialog(e));
    }

    /**
     * Handler for when close is clicked
     *
     * @param {event} e
     */
    handleCloseDialog(e) {
        e.preventDefault();
        this.closeDialog();
    }

    /**
     * Closes the dialog associated with this instance
     */
    closeDialog() {
        vex.close(this.vex.data().vex.id);
    }
}

$(window).load(function(){
    new VideoModal();
});



// WEBPACK FOOTER //
// ./src/js/components/video-modal.js